// extracted by mini-css-extract-plugin
export default {"ticket":"prices-module--ticket--447c3","title":"prices-module--title--d0e78","price":"prices-module--price--12cfe"};